export const emailToolbarConfig = {
  header: true,
  font: true,
  size: true,
  bold: true,
  italic: true,
  color: true,
  background: true,
  listBullet: true,
  listOrdered: true,
  align: true,
  addLink: true,
  addImage: true,
  addVariable: true,
}
